// import { $translate } from '@/utils/i18n';
export const tableConfig = {
    configuration: true,

    searchList: {
        searchTxt: [
            {
                type: 'input',
                value: 'customerOrderNo',
                span: 6,
                name: '单据号',
                clearable: true
                // name: $translate('lang.E3202101280001', {
                //     defaultText: '条码字符串'
                // })
            },
            {
                type: 'input',
                value: 'barcodeNo',
                span: 6,
                name: '条码',
                clearable: true
            },
            {
                type: 'input',
                value: 'taskNo',
                span: 6,
                name: '任务号',
                clearable: true
            },
            {
                type: 'input',
                value: 'batchNo',
                span: 6,
                name: '批次号',
                clearable: true
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        sequence: true,
        leftOperation: true,
        showOtpColumnConfig: true,
        selectBtn: true,
        rowKey: 'id',
        height: 'calc( 100vh - 220px )', // 样式被穿透了
        columns: [
            {
                label: '批次号',
                align: 'center',
                prop: 'batchNo',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '订单来源',
                align: 'center',
                prop: 'sourceSystem',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: '流向来源',
                align: 'center',
                prop: 'scanSystem',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '条码总数',
                align: 'center',
                prop: 'totalNum',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '成功数',
                align: 'center',
                prop: 'successNum',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '失败数',
                align: 'center',
                prop: 'failedNum',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '执行次数',
                align: 'center',
                prop: 'processTime',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '是否执行',
                align: 'center',
                prop: 'processFlag',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '执行日期',
                align: 'center',
                prop: 'processDate',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '写入日期',
                align: 'center',
                prop: 'creationDate',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '执行结果',
                align: 'center',
                prop: 'processDesc',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '发车单号',
                align: 'center',
                prop: 'dispatchNo',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '客户订单号',
                align: 'center',
                prop: 'customerOrderNo',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '任务号',
                align: 'center',
                prop: 'taskNo',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '客户编码',
                align: 'center',
                prop: 'customerCode',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '客户名称',
                align: 'center',
                prop: 'customerName',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '上游仓库编码',
                align: 'center',
                prop: 'upperWhCode',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '上游仓库名称',
                align: 'center',
                prop: 'upperWhName',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '收货仓库编码',
                align: 'center',
                prop: 'recOrgWhCode',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '收货仓库名称',
                align: 'center',
                prop: 'recOrgWhName',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '发货单位类型',
                align: 'center',
                prop: 'shipOrgType',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '收货单位类型',
                align: 'center',
                prop: 'recOrgType',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '出入库方向',
                align: 'center',
                prop: 'inOutType',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '业务类型编码',
                align: 'center',
                prop: 'orderType',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '业务类型名称',
                align: 'center',
                prop: 'orderTypeName',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '服务平台编码',
                align: 'center',
                prop: 'siteCode',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '服务平台',
                align: 'center',
                prop: 'siteName',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '业务模式',
                align: 'center',
                prop: 'businessMode',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '配送方式编码',
                align: 'center',
                prop: 'deliveryType',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '配送方式',
                align: 'center',
                prop: 'deliveryTypeName',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '扫码仓库编码',
                align: 'center',
                prop: 'whCode',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '扫码仓库名称',
                align: 'center',
                prop: 'whName',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '收货单位编码',
                align: 'center',
                prop: 'receiverCode',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '收货单位',
                align: 'center',
                prop: 'receiverName',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '物流公司编码',
                align: 'center',
                prop: 'logisticsCompanyCode',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '快递单号',
                align: 'center',
                prop: 'expressCode',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '承运商编码',
                align: 'center',
                prop: 'carrierCode',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '承运商名称',
                align: 'center',
                prop: 'carrierName',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '司机',
                align: 'center',
                prop: 'driver',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '柜号',
                align: 'center',
                prop: 'actContainerNo',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '关单日期',
                align: 'center',
                prop: 'closeDate',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '发货省编码',
                align: 'center',
                prop: 'senderProvinceCode',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '发货省名称',
                align: 'center',
                prop: 'senderProvinceName',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '发货市编码',
                align: 'center',
                prop: 'senderCityCode',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '发货市名称',
                align: 'center',
                prop: 'senderCityName',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '发货区编码',
                align: 'center',
                prop: 'senderDistrictCode',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '发货区名称',
                align: 'center',
                prop: 'senderDistrictName',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '发货街道编码',
                align: 'center',
                prop: 'senderTownCode',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '发货街道名称',
                align: 'center',
                prop: 'senderTownName',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '发货详细地址',
                align: 'center',
                prop: 'senderDetailAddrDees',
                filter: true,
                require: true,
                sort: false,
                width: 180
            },
            {
                label: '收货省编码',
                align: 'center',
                prop: 'receiverProvinceCode',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '收货省名称',
                align: 'center',
                prop: 'receiverProvinceName',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '收货市编码',
                align: 'center',
                prop: 'receiverCityCode',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '收货市名称',
                align: 'center',
                prop: 'receiverCityName',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '收货区编码',
                align: 'center',
                prop: 'receiverDistrictCode',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '收货区名称',
                align: 'center',
                prop: 'receiverDistrictName',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '收货街道编码',
                align: 'center',
                prop: 'receiverTownCode',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '收货街道名称',
                align: 'center',
                prop: 'receiverTownName',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '收货详细地址',
                align: 'center',
                prop: 'receiverDetailAddrDees',
                filter: true,
                require: true,
                sort: false,
                width: 180
            }
        ],
        action: [
            {
                type: 'text',
                label: '查看明细',
                color: '',
                event: 'detail'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
